import { ButtonColor } from "@/common/enum/button-color";
import { Button, Table } from "flowbite-react";
import React from "react";

interface Props {
  headersLength: number;
  handleAddDiscountsButtonClick: () => void;
}

export const ItemAllDiscountsTableFooter: React.FC<Props> = ({
  headersLength,
  handleAddDiscountsButtonClick,
}) => {
  return (
    <Table.Row className="sticky bottom-0 bg-white">
      <Table.Cell colSpan={headersLength + 1}>
        <div className="flex justify-between p-[16px] border-t">
          <Button
            size="sm"
            color={ButtonColor.TRANSPARENT_OUTLINE}
            onClick={handleAddDiscountsButtonClick}
          >
            할인 변경 상품 목록에 추가
          </Button>
        </div>
      </Table.Cell>
    </Table.Row>
  );
};
